import { useI18n } from '@monorepo/i18n';
import { useNotifications } from '@monorepo/notification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DeleteContactPersonRequest,
  UserBriefInfo
} from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { getGrpcPromise, TGRPCPromiseReject } from '@monorepo/grpc';
import { useCallback } from 'react';
import { QUERY_KEYS } from '@monorepo/helpers';
import { WebAuthService } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb_service';
import contactPersonConstructor from '../../utils/contactPersonConstructor';

const useDeleteContactPersonFO = () => {
  const { t } = useI18n();
  const { errorNotification, successNotification } = useNotifications();
  const queryClient = useQueryClient();

  const mutator = (
    item: DeleteContactPersonRequest.AsObject
  ): Promise<UserBriefInfo.AsObject> => {
    const request = new DeleteContactPersonRequest();

    if (item) {
      // @ts-ignore
      const itemInfo = contactPersonConstructor(item);
      request.setItem(itemInfo);
    }
    return getGrpcPromise(WebAuthService.DeleteContactPerson)(request);
  };

  const onSuccess = useCallback(() => {
    successNotification(t('updateUser.user.success'));
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
  }, [t, successNotification]);

  const onError = useCallback(
    (error: TGRPCPromiseReject) =>
      errorNotification(t(`updateUser.error.${error.status}`)),
    [t, errorNotification]
  );

  return useMutation<
    UserBriefInfo.AsObject | null,
    TGRPCPromiseReject,
    DeleteContactPersonRequest.AsObject
  >({ mutationFn: mutator, retry: false, onSuccess, onError });
};

export default useDeleteContactPersonFO;
